<template>
	<div class="video-container" :class="{ fullscreen: isFullscreen }">
		<!-- 占位节点 计算视频高度 -->
		<div class="video-shadow">
			<video ref="videoShadow">
				<source :src="videoSource" type="video/mp4" />
			</video>
		</div>
		<video ref="video" :poster="videoPoster">
			<source :src="videoSource" type="video/mp4" />
		</video>
		<div class="video-control" @click="togglePlayPause">
			<span>{{ isPlaying ? '暂停' : '播放' }}</span>
		</div>
		<div class="video-text" v-if="text && !isPlaying">
			{{ text }}
		</div>
	</div>
</template>

<script>
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

export default {
	props: {
		videoUrl: {
			type: String,
			default: ''
		},
		poster: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			default: ''
		},
		controls: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			player: null,
			videoSource: '',
			videoPoster: '',
			isPlaying: false,
			isFullscreen: false,
			onceStartOver: false
		};
	},
	watch: {
		isPlaying() {
			const customSpanNode = document.querySelector('.plyr__controls__middle-span');
			this.updateInnerHTML(customSpanNode);
		}
	},
	activated() {
		// 兼容页面跳转的时候 取不到这个节点导致的状态更新丢失
		if (!this.isPlaying) {
			const customSpanNode = document.querySelector('.plyr__controls__middle-span');
			this.updateInnerHTML(customSpanNode);
		}
	},
	mounted() {
		this.initPlayer();
	},
	beforeDestroy() {
		this.destroyPlayer();
	},
	methods: {
		initPlayer() {
			if (!this.videoUrl) return;
			if (!this.$refs.video) return;

			this.videoSource = this.videoUrl;
			if (this.poster) this.videoPoster = this.poster;

			const shadowNode = this.$refs.videoShadow;
			new Plyr(shadowNode, {
				controls: []
			});

			const realNode = this.$refs.video;
			this.player = new Plyr(realNode, {
				controls: this.controls
				// controls: ['fullscreen']
				// controls: ['play', 'progress', 'duration', 'volume', 'fullscreen']
			});
			this.player.on('play', () => {
				if (!this.onceStartOver) {
					this.onceStartOver = true;
					this.$emit('onceStart', shadowNode.clientHeight);
				}
				this.isPlaying = true;
			});
			this.player.on('pause', () => {
				this.isPlaying = false;
			});
			// 暂不支持全屏交互
			// this.player.on('enterfullscreen', () => {
			// 	this.isFullscreen = true;
			// });
			// this.player.on('exitfullscreen', () => {
			// 	this.isFullscreen = false;
			// });
		},
		destroyPlayer() {
			if (this.player) {
				this.player.destroy();
			}
		},
		updateInnerHTML(button) {
			if (!button) return;
			if (this.isPlaying) {
				// 当视频正在播放时，将按钮设置为暂停图标
				button.innerHTML = '暂停';
			} else {
				// 当视频暂停时，将按钮设置为播放图标
				button.innerHTML = '播放';
			}
		},
		togglePlayPause() {
			if (this.player.playing) {
				this.player.pause();
			} else {
				this.player.play();
			}
		}
	}
};
</script>

<style lang="less" scoped>
.video-container {
	position: relative;
	width: 100%;
	margin: 0 auto;

	.video-shadow {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		z-index: -1;
	}

	.video-control {
		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 12;
		transform: translate(-50%, -50%);
		padding: 0.03rem 0.08rem;
		background: rgba(0, 0, 0, 0.4);
		border-radius: 0.6rem;
		font-size: 0;

		span {
			color: #fff;
			font-family: PingFang SC;
			font-size: 0.12rem;
			font-style: normal;
			font-weight: 400;
			line-height: 0.16rem;
		}
	}

	.video-text {
		position: absolute;
		right: 0;
		left: 0;
		bottom: 0;
		color: #fff;
		padding: 0.03rem 0.08rem;
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);
		color: #fff;
		font-family: 'PingFang SC';
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 20px; /* 142.857% */
	}
}
</style>
